<template>
<div class="chapter">
<div class="inner_page">
<p class="book-title">1,000 Vegetarian Recipes</p>
<p class="author-byline"><span class="generated-style">Carol Gelles</span></p>
<p class="copyright-text" style="text-align:center; page-break-after:always">Houghton Mifflin Harcourt<br/>
			Boston ● New York ● 2015</p>
<p class="copyright-text"><span class="generated-style">Copyright © 1996 by Carol Gelles</span></p>
<p class="copyright-text">For information about permission to reproduce selections from this book, write to trade.permissions@hmhco.com or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="copyright-text"><span class="generated-style"><a href="http://www.hmhco.com" target="_blank">www.hmhco.com</a></span></p>
<p class="copyright-text"><span class="generated-style">A catalogue record is available from the Library of Congress.</span></p>
<p class="copyright-text"><span class="generated-style">eBook ISBN 978-0-544-18917-1</span></p>
<p class="copyright-text"><span class="generated-style">v2.0915</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ffirs-1.vue?2436f8b6